import i18next from '../../../../i18n';

export const readableErrorMessage = (error: string, extension?: string) => {
  if (
    error.includes('is not a supported format') ||
    error.includes('The following files have unsupported file types')
  ) {
    return error;
  }

  if (error.includes('exceeds maximum allowed size')) {
    return i18next.t('public.FileUpload.uploadErrors.invalidFileSize');
  }

  if (/You can only upload \d+ files/.test(error)) {
    return i18next.t('public.FileUpload.uploadErrors.tooManyFiles', {
      maxFiles: 10,
    });
  }

  if (/You can only upload:/.test(error)) {
    return i18next.t('public.FileUpload.uploadErrors.invalidFileType', {
      extension,
    });
  }

  if (error.includes('internal error')) {
    return i18next.t('public.FileUpload.uploadErrors.systemError');
  }

  return error;
};
